import screens from '@constants/theme/screens.config';
import styled from '@emotion/styled';

export const SadaHideMobile = styled.div`
  display: block;
  ${screens.mobile} {
    display: none;
  }
`;
